import { useStyles } from './styles'
import { AppButton } from '@/shared/ui/button'
import { lang } from '@/shared/constants/lang'
import { useUnit } from 'effector-react'
import { $userLanguage, $userToken } from '@/entities/user'
import WebApp from '@twa-dev/sdk'
import { goToShop } from '@/app/routing/events'

export const BuyMoreKeys = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const userToken = useUnit($userToken)

  const handleClick = async () => {
    if (userToken) {
      goToShop()
    } else {
      WebApp.showPopup({
        title: lang[userLang].webappPopup.error,
        message: lang[userLang].webappPopup.loginToBuy,
      })
    }
  }

  return (
    <div className={classes.root}>
      <img
        src="/assets/backgrounds/buyMoreKeys.webp"
        alt=""
        className={classes.background}
      />
      <div className={classes.divWrapper}>
        <span className={classes.boredText}>{lang[userLang].pages.boxPage.widgetTexts.buyKey.bored}</span>
      </div>
      <AppButton
        onClick={handleClick}
        variant="golden"
        className={classes.button}
      >
        <span className={classes.buttonText}>{lang[userLang].pages.boxPage.widgetTexts.buyKey.buyKeys}</span>
      </AppButton>
    </div>
  )
}
